import { css } from '@emotion/css'
import { colors, fontSize, fontWeight, spacing, mediaQueryHelper, breakpoint } from '@offerzen/pinata'

const styles = {
  emptyListCard: css({
    flexDirection: 'column',
    textAlign: 'center',
    padding: spacing.medium,
    gap: spacing.small,

    '& > *': {
      marginBottom: 0,
    },

    [mediaQueryHelper(breakpoint.tablet)]: {
      padding: spacing.large,
    },

    h4: {
      color: colors.oxfordBlue,
      fontSize: fontSize.medium,
      fontWeight: fontWeight.semiBold,
    },

    p: {
      color: colors.scorpion,
    },
  }),
}

export default styles
